

const ui = {
  navigation: {
    home: '主页',
    about: '关于',
    work: '工作',
    education: '教育',
    skill: '技能',
    portfolio: '作品集',
    testimonials: '评价'
  },
  navMenu: {
    showNav: '显示导航',
    hideNav: '隐藏导航'
  },
  about: {
    title: '关于我',
    subtitle: '联系方式'
  },
  skills: {
    title: '技能',
  },
  modal: {
    details: '详情',
    close: '关闭'
  },
  portfolio: {
    title: '作品集'
  },
  work: {
    title: '工作经历'
  },
  education: {
    title: '教育'
  },
  references: {
    title: '评价'
  },
  footer: {
    description: 
    `该简历模板基于React开发，原作者为{author1}，设计作者为{author2}。由{author3}基于ES6进行重构，并添加中英文语言支持`,
    authorName: '郭小洋'
  }
}
export default  ui;


// WEBPACK FOOTER //
// ./src/template/ui.zh_CN.js